<script lang="js">
import { defineComponent } from "@vue/runtime-core";
import { Api } from "onpage-js";
import ListaCollezioni from "./ListaCollezioni.vue";
import ListaProdotti from "./ListaProdotti.vue";
// import { useRouter, useRoute } from 'vue-router';

export default defineComponent({
  setup() {
    return {
      ListaCollezioni,
      ListaProdotti,
    };
  },
  data() {
    return {
      schema: undefined,
      pagine_web: null,
    };
  },
  methods: {
    setLanguage(lang) {
      console.log('impostazione lingua :', lang)
        localStorage.setItem('selectedLanguage', lang);
    },
    pagineWeb_query(){
      const schema = this.schema;
      if (!schema) return;

      if(window.datalang){ // eslint-disable-next-line 
        schema.lang = window.datalang.split("_")[0] // eslint-disable-next-line 
      }

      const q = schema.query("pagine_web").with("header").with("sezioni.box_capitoli").with("documentazione.tipologia_documento");
      return q;
    },
    updateLanguage() {
      console.log('lingua aggiornata')
      // const query = this.$route.query;
      // const lang = query.lang;
      // console.log('aggiornamento lingua')
      if(this.schema && this.schema.lang){
        this.schema.lang = 'it'
        this.setLanguage(this.schema.lang)
        // if (lang) {
        //   this.schema.lang = lang;
        // } else {
        //   // Imposta un valore di default se il parametro 'lg' non è presente nell'URL
        //   this.schema.lang = 'it'; // Ad esempio, 'it' per italiano
        // }
      } else {
        console.log('schema non trovato')
      }
    },
    delayUpdate() {
      console.log('La funzione verrà eseguita dopo 3 secondi.');
      setTimeout(this.updateLanguage(), 3000);
    },
  },
  watch: {
    '$route': {
      immediate: true,
      handler: function () {
        if (this.schema) {
          this.updateLanguage();
        }
        setTimeout(() => {
          window.document.getElementById('app').scrollIntoView();
        }, 400);  // Ritarda lo scroll di 1 secondo
        this.$nextTick(() => {
          window.document.getElementById('app').scrollIntoView()
        });
        // window.document.getElementById('app').scrollIntoView()
      }
    },
    'schema': {
      immediate: true,
      handler: function () {
        if (this.schema) {
          this.updateLanguage();
        }
      }
    },
  },

  async created() {
    let api = new Api("app", "lDeX7TmwIP3uZbel");
    this.schema = await api.loadSchema();
    this.schema.fallback_lang = 'it'
    if(this.schema){
      console.log(this.schema.label, "is ready");
      this.updateLanguage()
      this.pagine_web = await this.pagineWeb_query().all();
    }else{
      console.log(this.schema.label,"not ready");
    }

    if(this.pagine_web){
      console.log("Pagine web","is ready");
    }else{
      console.log("Pagine web","not ready");
    }
  },
  scrollToTop() {
      this.$nextTick(() => {
        window.document.getElementById('app').scrollIntoView();
      });
    },
  mounted(){
    this.updateLanguage()
    window.addEventListener('load', this.scrollToTop);
    // this.delayUpdate()
  },
  beforeUnmount() {
    window.removeEventListener('load', this.scrollToTop);
  },
  
});
</script>

<template>
  <div v-if="!schema"></div>
  <div v-else>
    <router-view :schema="schema" :pagine_web="pagine_web" />
    <!-- <component :is="ListaProdotti" :schema="schema" /> -->
  </div>
</template>


<style>
@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@100;200;300;400;600&display=swap');
#app{
  overflow-x: hidden;
}
*{
  font-family: 'Poppins', sans-serif;
}
</style>